import { format, parse, parseISO } from 'date-fns'
import BR from 'date-fns/locale/pt-BR'
import { Row } from 'react-table'

export const weekNamesLong = [
	'Domingo',
	'Segunda',
	'Terça',
	'Quarta',
	'Quinta',
	'Sexta',
	'Sábado',
]

export const weekNamesShort = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']

export const monthNamesArray = [
	'Janeiro',
	'Fevereiro',
	'Março',
	'Abril',
	'Maio',
	'Junho',
	'Julho',
	'Agosto',
	'Setembro',
	'Outubro',
	'Novembro',
	'Dezembro',
]

export function sortDate(param: string) {
	return (rowA: Row, rowB: Row, _: string, __: boolean) => {
		//		const a = reverseDate(rowA.values[param])
		//		const b = reverseDate(rowB.values[param])
		const a = rowA.values[param]
		const b = rowB.values[param]

		if (a < b) return -1
		if (a > b) return 1
		return 0
	}
}

/**
 *
 * @param string dd/MM/yyyy
 * @returns yyyy-MM-dd
 */
export function reverseDate(date: string): string {
	const val = date.split('/')
	return `${val[2]}-${val[1]}-${val[0]}`
}

/**
 *
 * @param date yyyy-mm-dd
 */
export function parseDate(date: string): Date {
	return parse(date, 'yyyy-mm-dd', new Date(), { locale: BR })
}

/**
 *
 * @param date
 * @returns dd/MM/yyyy HH:mm
 */
export function formatDate(date: Date): string {
	return format(date, 'dd/MM/yyyy HH:mm', { locale: BR })
}

/**
 *
 * @param date ISODate yyyy-MM-dd'T'HH:mm:ss.SSSxxx
 * @returns dd/MM/yyyy HH:mm
 */
export function parseFormat(date: string): string {
	return format(parseISO(date), 'dd/MM/yyyy HH:mm', { locale: BR })
}
